import { Component, Inject } from "@angular/core";
import { ColumnConfigType, OptionalColumn, SimpleTableColumnConfig } from "@nms-angular-toolkit/nms-simple-table";
import { PRIMARY_PRESSED_COLOR } from "@nms-ng2/app/shared/constants/colors";
import { ANGULARJS_TRANSLATE } from "@nms-ng2/app/shared/services/upgraded-provider/upgraded-providers";
import { SimpleModalComponent } from "ngx-simple-modal";
import { AlarmDiagnosticData, AlarmSeverity } from "../../dwdm-circuit.model";
import { ALARM_SEVERITY, AlarmDetailsData } from "./alarm-details-model";

/**
 * Modal de visualização dos detalhes do alarme.
 */
@Component({
    selector: "alarm-details",
    templateUrl: "./alarm-details.component.html",
    styleUrls: ["./alarm-details.component.scss"]
})
export class AlarmDetailsComponent extends SimpleModalComponent<AlarmDetailsData, any> implements AlarmDetailsData {
    readonly pageTitle: string = "dwdm.circuit.modal.alarm.details.title";
    alertDetailsColumns: SimpleTableColumnConfig[] = [];
    columnsSortable: Record<string, boolean> = {
        device: true,
        sourceType: true,
        sourceValue: true,
        name: true,
        info: true,
        time: true,
        unstable: true,
        severity: true
    };

    alarmDiagnosticData: Array<AlarmDiagnosticData>;

    constructor(@Inject(ANGULARJS_TRANSLATE) private readonly translate: any) {
        super();

        this.alertDetailsColumns = [
            {
                field: "deviceName",
                label: "Device",
                customColor: PRIMARY_PRESSED_COLOR
            },
            {
                field: "sourceType",
                label: "Source-type"
            },
            {
                field: "sourceValue",
                label: "Source-value"
            },
            {
                field: "name",
                label: "Name"
            },
            {
                field: "information",
                label: "Info"
            },
            {
                field: "time",
                label: "Time"
            },
            {
                field: "unstable",
                label: "Unstable",
                getCustomText: (row) => (row.unstable ? "True" : "False")
            },
            {
                field: "severity",
                label: "Severity",
                optionalColumn: this.getStatusOptionColumn()
            }
        ];
    }

    private getStatusOptionColumn(): OptionalColumn {
        return {
            type: ColumnConfigType.STATUS,
            variant: "circle",
            convert: (severity: string) => {
                const { translationKey, bgColor, color } =
                    ALARM_SEVERITY[AlarmSeverity[severity.trim().toUpperCase()].toString()];
                const label = this.translate.instant(translationKey);

                return { label, bgColor, color };
            }
        };
    }
}
